import React, { useCallback } from 'react';
import { Popover, message } from 'antd';
import { copyText } from '@/utils/clipboard';

function hexToRgb(hex) {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return 'rgb(' + r + ', ' + g + ', ' + b + ')';
}

function getTextColor(bgColor) {
  try {
    // 将背景颜色转换为RGB值
    const rgb = hexToRgb(bgColor)?.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    const r = rgb[1];
    const g = rgb[2];
    const b = rgb[3];

    // 计算亮度
    // eslint-disable-next-line radix
    const brightness = Math.round((parseInt(r) * 299 + parseInt(g) * 587 + parseInt(b) * 114) / 1000);

    // 如果亮度小于125，则文本为白色，否则为黑色
    const textColor = brightness < 125 ? '#fff' : '#000';

    return textColor;
  } catch (e) {
    return '#000';
  }
}

const QUICK_BTN_STYLE = {
  cursor: 'pointer',
  height: '32px',
  padding: '5px 16px',
  fontSize: '14px',
  boxSizing: 'border-box',
  display: 'inline-block',
  borderRadius: '15px'
};

const QuickBtns = props => {
  const { btn_text, btn_type = '', content = '', style = {}, func_id, id, func, conv_id } = props;
  const renderStyle = () => {
    const { color = '', bg } = style;
    let obj = {};
    if (bg === 1) {
      obj = {
        backgroundColor: color,
        color: getTextColor(color)
      };
    } else {
      obj = {
        color,
        border: `1px solid ${color}`
      };
    }
    return obj;
  };

  const onClick = useCallback(() => {
    switch (btn_type) {
      // 复制内容
      case 1:
        copyText(content);
        message.success(`${'已复制'}`);
        break;
      // 拨打电话
      case 2:
        window.open('tel:' + content);
        break;
      // 跳转链接
      case 3:
        window.open(content);

        break;
      // 发送消息
      case 4:
        message.success(`${'当前类型按钮在客服端不生效'}`);

        break;
      // 图片浮层
      case 5:
        break;
      // 自助问答
      case 6:
        message.success(`${'当前类型按钮在客服端不生效'}`);
        break;
      default:
        break;
    }
  }, [btn_type, content, btn_text]);

  const popContent = <img src={content} alt="" style={{ width: 180, height: 180 }} />;

  return (
    <div>
      {btn_type === 5 ? (
        <Popover content={popContent}>
          <div style={{ ...QUICK_BTN_STYLE, ...renderStyle() }} onClick={onClick}>
            {btn_text}
          </div>
        </Popover>
      ) : (
        <div style={{ ...QUICK_BTN_STYLE, ...renderStyle() }} onClick={onClick}>
          {btn_text}
        </div>
      )}
    </div>
  );
};

export default QuickBtns;
